import React, { useEffect } from 'react';
import '.././PopupCommonStyle.css';
import styles from './Style.module.css';
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnSecondary } from '../../Buttons/BtnSecondary';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../../../Context/UI/UIContext';
import { useBookingSession } from '../../../Context/BookingSession/BookingSessionContext';

export const DiscardPopup = () => {
  const { isDiscardPopupActive, setIsDiscardPopupActive } = useUI();
  const { uuid, bookingUpdate } = useBookingSession();
  const appointmentUuid = bookingUpdate && uuid ? uuid : null;

  const handleClose = () => {
    setIsDiscardPopupActive(false);
  };

  useEffect(() => {
    if(isDiscardPopupActive){
      document.body.classList.add('overlay', 'overflow-hidden', 'overlay-index');
    }else{
      document.body.classList.remove('overlay', 'overflow-hidden', 'overlay-index');
    }
  }, [isDiscardPopupActive]);

  
  const navigate = useNavigate();

  const handleDiscard = async () => {
    setIsDiscardPopupActive(false);
    if (appointmentUuid) {
      navigate(`/appointment/${appointmentUuid}`);
    } else {
      navigate('/');
    }
  };


  return (
    <div className={`${styles.discardPopup} popup ${isDiscardPopupActive ? "show" : ""}`}>
      <div className={`${styles.popHeader} popup-header`}>
      <h2 className="title">Warning!</h2>
      <h6 className="titleSub">Are you sure you want to discard the rescheduled booking?</h6>
      </div>
      <div className={`${styles.ecFooter} popup-footer`}>
          <BtnSecondary label="Cancel" handleClick={handleClose} customClass="w-100 no-icon"/>
          <BtnPrimary label="Yes, Discard" handleClick={handleDiscard} customClass="w-100 no-icon"/>
      </div>
    </div>
  )
}
